
import { Action             } from "@/models/action";
import { ActionType         } from "@/models/action.type";
import { Logger             } from "@/util/logger";
import { PanoramaController } from "@/components/panorama.controller";

export class PanoZoomOutAction extends Action {

  /** how much to zoom by */
  public _percentDelta = 5.0;

  /** the panoramic controller that can actually do stuff for us */
  private _controller : PanoramaController = null;

  /** standard constructor */
  constructor(controller : PanoramaController) {
    super({
      key:   ActionType.PANO_ZOOM_OUT,
      type:  ActionType.PANO_ZOOM_OUT,
      label: 'Zoom In',
      icon:  '',
      tip:   ''
    });

    this._controller = controller;
  }

  /** set the delta amount (percentage 0-100) */
  public setDelta(percentDelta: number = 5.0) {

    this._percentDelta = percentDelta;
  }

  /** fetch the delta amount (percentage 0-100) */
  public delta(): number {

    return this._percentDelta;
  }

  /** fetch the panoramic controller */
  public controller(): PanoramaController {

    return this._controller;
  }

  /** implement the action */
  public execute() : boolean {

    this._controller.zoomOut(this._percentDelta);

    return true;
  }
}
